export default __webpack_public_path__ + "static/media/whatsapp.c81ad36e.svg";